module.exports = __webpack_public_path__ + "img/pos-icon.227d7315.svg";